import React from 'react';
import { MessageCircle, Users, Heart, Shield, Calendar } from 'lucide-react';
export function ContentBreakdown() {
  const modules = [{
    id: 1,
    title: 'Las Palabras que Sanan',
    desc: '5 frases exactas que tu familiar necesita escuchar — y las 3 que lo hieren aunque vengan del amor.',
    icon: MessageCircle
  }, {
    id: 2,
    title: 'El Equipo Familiar',
    desc: 'Cómo organizar los roles para que nadie se agote. El cáncer es una guerra familiar, no individual.',
    icon: Users
  }, {
    id: 3,
    title: 'La Presencia Real',
    desc: 'Cómo estar presente de verdad — no solo físicamente, sino en el alma. Acompaña el espíritu.',
    icon: Heart
  }, {
    id: 4,
    title: 'Tu Propio Blindaje',
    desc: 'Cómo sostenerte sin quebrarte. Protege tu salud mental para poder proteger la de tu familiar.',
    icon: Shield
  }, {
    id: 5,
    title: 'El Sistema de 7 Días',
    desc: 'Un plan diario simple para los primeros 7 días. Un tracker para estabilizar emocionalmente a tu familia.',
    icon: Calendar
  }];
  return;
}